<template v-slot:ShoppingCart>
  <div class="sim-cart-outer">
    <div class="app-checkout-shoppingcart-wrapper">
      <h4><slot name="headlineShoppingCart">Deine Bestellübersicht</slot></h4>
      <div class="promo-container">
        <b-row>
          <b-col class="col-lm-auto col">
            <div class="row" v-if="isEsim">
              <div class="pTtop"><slot name="lableESimShoppingCart">eSIM</slot></div>
              <div class="pSsub"><slot name="lableESimSublineShoppingCart">(einmalig)</slot></div>
            </div>
            <div class="row" v-else>
              <div class="pTtop"><slot name="lableSimShoppingCart">Triple SIM-Karte</slot></div>
              <div class="pSsub"><slot name="lableSimSublineShoppingCart">(einmalig)</slot></div>
            </div>
          </b-col>
          <b-col>
            <span class="pPrice">
              {{ priceWithoutEuro(getSimCardOption.productPrice) }} <span class="pSign">€</span>
            </span>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col class="col-lm-auto col">
            <div class="row">
              <div class="pTtop"><slot name="lableShippingShoppingCart">Versandkosten</slot></div>
              <div class="pSsub"><slot name="lableShippingSublineShoppingCart">(einmalig)</slot></div>
            </div>
          </b-col>
          <b-col class="addPrice">
            {{ formattedShipping }} €
          </b-col>
        </b-row>
        <hr>
      </div>
      <b-row class="cDiv" v-if="isFreeEsim">
        <b-col>
          <ul class="check-list">
            <li class="with-paw">
              <slot name="listFreeEsimShoppingCart">Die ersten 30 Tage: <strong>Kostenlos</strong> zur eSIM wechseln</slot>
            </li>
          </ul>
        </b-col>
      </b-row>
      <div class="lDiv">
        <b-col class="pInfo"><slot name="txtMwStInfoShoppingCart">Alle Preise inkl. MwSt.</slot></b-col>
      </div>
    </div>
    <div class="app-checkout-shoppingcart-img">
      <slot name="imgShoppingCart"></slot>
    </div>
  </div>
</template>

<script>
import { BCol } from 'bootstrap-vue'
import shoppingCartMobile from '@/mixins/shoppingCartMobile'
import { mapGetters } from 'vuex'
import priceWithoutEuro from '@/mixins/formatters/price'

export default {
  name: 'SimShoppingCartWrapper',
  data () {
    return {}
  },
  components: {
    BCol
  },
  mixins: [
    priceWithoutEuro,
    shoppingCartMobile()
  ],
  computed: {
    ...mapGetters('substituteSimCard', [
      'setSubstituteSimCardOptions',
      'getSimCardOption',
      'isFreeEsim',
      'isEsim'
    ]),
    formattedShipping: function () {
      // Ausnahme, da die 0 keine Nachkommastellen haben soll
      if (this.getSimCardOption.shippingCosts !== 0) {
        return this.priceWithoutEuro(this.getSimCardOption.shippingCosts)
      } else {
        return 0
      }
    }
  },
  methods: {
    onScroll (e) {
      if (e.deltaY !== -1) {
        document.getElementById('main').scrollBy(0, e.deltaY)
      }
    }
  },
  mounted () {
    // damit rechter Teil des Warenkorbs scrollt, waehrend links gescrollt wird :)))))
    document.getElementById('left').addEventListener('wheel', this.onScroll, false)
  }
}
</script>
